(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Event', function($resource, DateUtils) {
        return $resource(
            'api/events/:mode/:id',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET'
                },
                update: {
                    method: 'PUT',
                    transformRequest: function(data) {
                        data.publicationDate = DateUtils.convertLocaleDateToServer(data.publicationDate);
                        data.eventStart = DateUtils.convertLocaleDateFromServer(data.eventStart);
                        data.eventStop = DateUtils.convertLocaleDateFromServer(data.eventStop);
                        return angular.toJson(data);
                    }
                },
                save: {
                    method: 'POST',
                    transformRequest: function(data) {
                        data.publicationDate = DateUtils.convertLocaleDateToServer(data.publicationDate);
                        data.eventStart = DateUtils.convertLocaleDateFromServer(data.eventStart);
                        data.eventStop = DateUtils.convertLocaleDateFromServer(data.eventStop);
                        return angular.toJson(data);
                    }
                }
            }
        );
    });
})();
